module.exports = __webpack_public_path__ + "static/media/Gwiazda.ba9bf306.svg";